import React from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from "axios";
import { config } from '../App';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#282c34',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
  };

const Modals = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const [videoLink, setVideoLink] = React.useState("")
  const handleVideoLink = (event) => {
    setVideoLink(event.target.value)
  }

  const [thumbNailLink, setThumbNailLink] = React.useState("")
  const handleThumbNailLink = (event) => {
    setThumbNailLink(event.target.value)
  }

  const [title, setTitle] = React.useState("")
  const handleTitle = (event) => {
    setTitle(event.target.value)
  }

  const [genre, setGenre] = React.useState('');
  const handleGenre = (event) => {
    setGenre(event.target.value);
  };

  const [rating, setRating] = React.useState('');
  const handleRating = (event) => {
    setRating(event.target.value);
  };

  const [date, setDate] = React.useState(null);

  let postURL = config.endpoint + '/v1/videos'

  const handleSubmit = async() => {
    console.log('Submit clicked');
    let regex = new RegExp(
      /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?[\w\?=]*)?/
    );
    if(regex.test(videoLink)){
      let enteredURL = videoLink.split("v=")[1].split("&")[0]
      const payload = {
        videoLink: `youtube.com/embed/${enteredURL}`,
        thumbNailLink: thumbNailLink,
        title: title,
        genre: genre,
        rating: rating,
        date: date
      }

      const res = await axios.post(postURL, {payload})
      console.log(res, res.data);
      if(res.data){
        handleClose()
      }
    }
    else{
      console.log("Not a valid link");
    }
  }

  return (
    <Grid item xs={3} sx={{ textAlign: "right" }} p={2}>
      <Button id="upload-btn"
        startIcon={<FileUploadIcon />}
        variant="contained"
        onClick={handleOpen}
      >
        Upload
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography
              id="modal-modal-title"
              variant="modal"
            >
              Upload Video
            </Typography>
            <CloseIcon color="close" onClick={handleClose} />
          </Stack>

          <Box pt={2}
            component="form"
            noValidate
            autoComplete="off"
          >
            <TextField
              InputLabelProps={{
                style: { color: "#fff" },
              }}
              color="close"
              sx={{ input: { color: 'white' }, width: "100%" }}
              id="outlined-basic"
              label="Video Link"
              variant="outlined"
              value={videoLink}
              onChange={handleVideoLink}
            />
            <small style={{color: "white"}}>
              This link will be used to derive the video
            </small>
          </Box>

          <Box pt={2}
            component="form"
            noValidate
            autoComplete="off"
          >
            <TextField
              InputLabelProps={{
                style: { color: "#fff" },
              }}
              color="close"
              sx={{ input: { color: 'white' }, width: "100%" }}
              id="outlined-basic"
              label="Thumbnail Image Link"
              variant="outlined"
              value={thumbNailLink}
              onChange={handleThumbNailLink}
            />
            <small style={{color: "white"}}>
              This link will be used to preview the thumbnail image
            </small>
          </Box>

          <Box pt={2}
            component="form"
            noValidate
            autoComplete="off"
          >
            <TextField
              color="close"
              InputLabelProps={{
                style: { color: "#fff" },
              }}
              sx={{ input: { color: 'white' }, width: "100%" }}
              id="outlined-basic"
              label="Title"
              variant="outlined"
              value={title}
              onChange={handleTitle}
            />
            <small style={{color: "white"}}>
              The title will be the representative text for video
            </small>
          </Box>

          <Box pt={2}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label" sx={{ input: { color: 'white' }, color: "#fff" }}>
                Genre
              </InputLabel>
              <Select sx={{ input: { color: 'white' } }}
                color="close"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={genre}
                label="Genre"
                onChange={handleGenre}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Education">Education</MenuItem>
                <MenuItem value="Sports">Sports</MenuItem>
                <MenuItem value="Comedy">Comedy</MenuItem>
                <MenuItem value="Lifestyle">Lifestyle</MenuItem>
              </Select>
            </FormControl>
            <small style={{color: "white"}}>
              Genre will help in categorizing your videos
            </small>
          </Box>

          <Box pt={2}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label" sx={{ input: { color: 'white' }, color: "#fff" }}>
                Suitable age group for the clip
              </InputLabel>
              <Select  sx={{ backgroundColor: '#282c34' }}
                color="close"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={rating}
                label="Suitable age group for the clip"
                onChange={handleRating}
              >
                <MenuItem value="Any">Any</MenuItem>
                <MenuItem value="7">7+</MenuItem>
                <MenuItem value="12">12+</MenuItem>
                <MenuItem value="16">16+</MenuItem>
                <MenuItem value="18">18+</MenuItem>
              </Select>
            </FormControl>
            <small style={{color: "white"}} >
              This will be used to filter videos on age group suitability
            </small>
          </Box>

          <Box pt={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Basic example"
                value={date}
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} sx={{ input: { color: 'white' }, width: "100%" }} color="close" InputLabelProps={{
                    style: { color: "#fff" },
                  }}/>
                )}
              />
            </LocalizationProvider>
          </Box>
          <small style={{color: "white"}}>This will be used to sort videos</small>

          <Box pt={2}>
            <ButtonGroup aria-label="outlined button group">
              <Button variant="contained" color="error" onClick={handleSubmit} id="upload-btn-submit">
                UPLOAD VIDEO
              </Button>
              <Button onClick={handleClose} color={"close"} id="upload-btn-cancel">
                CANCEL
              </Button>
            </ButtonGroup>
          </Box>
        </Box>
      </Modal>
    </Grid>
  );
}

export default Modals